import { render, staticRenderFns } from "./BCXNavigationItems.vue?vue&type=template&id=42ca3fc3&scoped=true"
import script from "./BCXNavigationItems.vue?vue&type=script&lang=ts"
export * from "./BCXNavigationItems.vue?vue&type=script&lang=ts"
import style0 from "./BCXNavigationItems.vue?vue&type=style&index=0&id=42ca3fc3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ca3fc3",
  null
  
)

export default component.exports